export default __webpack_public_path__ + "static/eHjOswOz-a6653637f419c1923e640e8e0cc2e9a9.svg";